import { Route, Routes } from 'react-router-dom';
import { MainPage, InfoPage } from './pages';
import RootLayout from './components/layouts/RootLayout';

function Routers() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route path="/" element={<InfoPage />} />
        {/* <Route path="/info" element={<InfoPage />} /> */}
      </Route>
    </Routes>
  );
}

export default Routers;
